import { Colors } from "../../shared/colors/colors";
import styled from "styled-components";
import { Fonts } from "../../shared/fonts/fonts";
import { IoIosArrowDown } from "react-icons/io";

export const SelectContainer = styled.div<{
  hasIconLeft: boolean;
  hasIconRight: boolean;
  width?: number;
  error: boolean;
  disabled?: boolean;
}>`
  width: ${(props) => props.width ? `${props.width}px` : `100%`};
  display: flex;
  align-items: center;
  justify-content: start;
  border: 1px solid
    ${(props) => (props.error ? Colors.error : Colors.borderInput)};
  border-radius: 8px;
  padding-left: ${(props) => (props.hasIconLeft ? 19 : 0)}px;
  padding-right: ${(props) => (props.hasIconRight ? 19 : 0)}px;
  position: relative; /* Necessário para posicionar a seta */
  box-sizing: border-box;
  background-color: ${(props) =>
    props.disabled ? Colors.disabledInput : Colors.white};
`;

export const Select = styled.select<{
  color: string;
  id: string;
  placeholder: string;
  error: boolean;
  disabled?: boolean;
}>`
  color: ${(props) =>
    props.disabled
      ? Colors.disabledInputText
      : props.color === Colors.placeholder
        ? Colors.placeholder
        : Colors.black};
  background-color: ${(props) =>
    props.disabled ? Colors.disabledInput : Colors.white};
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: ${Fonts.primary};
  font-size: 14px;
  padding: 10px; /* Aplicando o padding corretamente */
  box-sizing: border-box;
  appearance: none; /* Oculta a seta padrão */
  -webkit-appearance: none; /* Para Safari */
  -moz-appearance: none; /* Para Firefox */
  padding-right: 30px; /* Espaço para a seta personalizada */
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  /* Garantindo que o select fique com a mesma aparência do input */
  &::placeholder {
    font-family: ${Fonts.primary};
    color: ${Colors.placeholder};
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }

  /* Estilo para quando o select não tem valor selecionado (mostra o placeholder) */
  &:invalid,
  option:first-of-type {
    color: ${Colors.placeholder};
  }

  /* Estilo para as opções selecionadas */
  option:not(:first-of-type) {
    color: ${Colors.black};
  }

  /* Estilo para quando o select tem valor selecionado */
  &:valid:not([value=""]) {
    color: ${Colors.black};
  }

  /* Classe específica para quando está exibindo o placeholder */
  &.placeholder-select {
    color: ${Colors.disabledInputText} !important;
  }

  /* Classe específica para quando tem valor selecionado */
  &.value-select {
    color: ${Colors.black} !important;
  }

  /* Garantir que a primeira opção sempre tenha a cor do placeholder */
  & > option:first-child {
    color: ${Colors.placeholder};
  }
`;

/* Estilo para a seta personalizada */
export const ArrowIcon = styled(IoIosArrowDown)`
  position: absolute;
  right: 10px; /* Posiciona a seta à direita */
  top: 50%;
  transform: translateY(-50%); /* Centraliza verticalmente */
  pointer-events: none; /* Impede a interação com o ícone */
  color: ${Colors.arrowSelect}; /* Cor da seta personalizada */
  font-size: 22px; /* Tamanho da seta */
`;
